<template>
  <p class="text-basics-primary text-xl font-serif">
    <slot></slot>
  </p>
</template>

<script lang="ts" setup></script>
